/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { claimsGetAllClaimsAccess } from '../fn/claims/claims-get-all-claims-access';
import { ClaimsGetAllClaimsAccess$Params } from '../fn/claims/claims-get-all-claims-access';
import { claimsGetClaimsAccessForMenu } from '../fn/claims/claims-get-claims-access-for-menu';
import { ClaimsGetClaimsAccessForMenu$Params } from '../fn/claims/claims-get-claims-access-for-menu';
import { claimsGetClaimsList } from '../fn/claims/claims-get-claims-list';
import { ClaimsGetClaimsList$Params } from '../fn/claims/claims-get-claims-list';
import { CustomResultOfListOfControllerActionsDto } from '../models/custom-result-of-list-of-controller-actions-dto';
import { CustomResultOfListOfKeyValuePairOfIntegerAndString } from '../models/custom-result-of-list-of-key-value-pair-of-integer-and-string';

@Injectable({ providedIn: 'root' })
export class ClaimsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `claimsGetClaimsList()` */
  static readonly ClaimsGetClaimsListPath = '/Claims/GetClaimsList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `claimsGetClaimsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  claimsGetClaimsList$Response(params?: ClaimsGetClaimsList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfControllerActionsDto>> {
    return claimsGetClaimsList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `claimsGetClaimsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  claimsGetClaimsList(params?: ClaimsGetClaimsList$Params, context?: HttpContext): Observable<CustomResultOfListOfControllerActionsDto> {
    return this.claimsGetClaimsList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfControllerActionsDto>): CustomResultOfListOfControllerActionsDto => r.body)
    );
  }

  /** Path part for operation `claimsGetAllClaimsAccess()` */
  static readonly ClaimsGetAllClaimsAccessPath = '/Claims/GetAllClaimsAccess';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `claimsGetAllClaimsAccess()` instead.
   *
   * This method doesn't expect any request body.
   */
  claimsGetAllClaimsAccess$Response(params?: ClaimsGetAllClaimsAccess$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfKeyValuePairOfIntegerAndString>> {
    return claimsGetAllClaimsAccess(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `claimsGetAllClaimsAccess$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  claimsGetAllClaimsAccess(params?: ClaimsGetAllClaimsAccess$Params, context?: HttpContext): Observable<CustomResultOfListOfKeyValuePairOfIntegerAndString> {
    return this.claimsGetAllClaimsAccess$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfKeyValuePairOfIntegerAndString>): CustomResultOfListOfKeyValuePairOfIntegerAndString => r.body)
    );
  }

  /** Path part for operation `claimsGetClaimsAccessForMenu()` */
  static readonly ClaimsGetClaimsAccessForMenuPath = '/Claims/GetClaimsAccessForMenu';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `claimsGetClaimsAccessForMenu()` instead.
   *
   * This method doesn't expect any request body.
   */
  claimsGetClaimsAccessForMenu$Response(params?: ClaimsGetClaimsAccessForMenu$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfKeyValuePairOfIntegerAndString>> {
    return claimsGetClaimsAccessForMenu(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `claimsGetClaimsAccessForMenu$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  claimsGetClaimsAccessForMenu(params?: ClaimsGetClaimsAccessForMenu$Params, context?: HttpContext): Observable<CustomResultOfListOfKeyValuePairOfIntegerAndString> {
    return this.claimsGetClaimsAccessForMenu$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfKeyValuePairOfIntegerAndString>): CustomResultOfListOfKeyValuePairOfIntegerAndString => r.body)
    );
  }

}
